import { privateApi } from 'services';
import { UserPreferences } from './types';

const updateUserPreferences = async (userId: string, userPreferences: UserPreferences): Promise<UserPreferences> =>
    privateApi.patch<UserPreferences>(`users/${userId}/preferences`, userPreferences);

export const UserPreferencesGateway = {
    updateUserPreferences,
};
